<template>
  <!-- 最终受益人 - 个人类型表单面板(弹窗编辑/回显平铺 复用) -->
  <el-form
    ref="formRef"
    :model="form"
    :rules="rules"
    label-position="top"
    :disabled="isReadonly"
    :class="{ readOnlyStyle: isReadonly }"
    class="personalForm"
  >
    <el-row :gutter="20" class="pt22">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardName')" prop="fullName" ref="fullName">
          <el-input v-model="form.fullName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.nationality')" prop="nationality" ref="nationality">
          <el-select v-model="form.nationality" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
            <el-option v-for="item of globalFormatList('nationalityList')" :key="`personalNat-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardType')" prop="identificationType" ref="identificationType">
          <el-select v-model="form.identificationType" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option v-for="item of byCountryFormatList('identificationData')" :key="`personalIdType-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardNo')" prop="identificationNo" ref="identificationNo">
          <el-input v-model="form.identificationNo" :placeholder="$t('common.placeholder.enter')" v-regexFilter="$halfWidthRegex" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.phone')" prop="phone" ref="phone">
          <prefix-phone v-model="form.phone" class="wdb100"></prefix-phone>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.email')" prop="email" ref="email">
          <el-input v-model="form.email" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="!isMalaysia">
        <el-form-item :label="$t('enroll.intitle.address')" prop="residentialAddress" ref="residentialAddress">
          <el-input v-model="form.residentialAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.birthDate')" prop="birthDate" ref="birthDate">
          <el-date-picker
            v-model="form.birthDate"
            type="date"
            :placeholder="$t('common.placeholder.select')"
            value-format="yyyy-MM-dd"
            class="wdb100"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.isHasPrcInland')" prop="isHoldShareOfPrcInland" ref="isHoldShareOfPrcInland">
          <el-select v-model="form.isHoldShareOfPrcInland" :placeholder="$t('common.placeholder.select')" @change="isHoldShareOfPrcInlandChange" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="form.isHoldShareOfPrcInland">
        <el-form-item :label="$t('enroll.intitle.prcInlandName')" prop="holdShareOfPrcEntity" ref="holdShareOfPrcEntity">
          <el-input v-model="form.holdShareOfPrcEntity" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <!-- 马来西亚专属 - 个人额外信息 -->
      <template v-if="isMalaysia">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.gender')" prop="gender" ref="gender">
            <el-select v-model="form.gender" :placeholder="$t('common.placeholder.select')" class="wdb100">
              <el-option v-for="item of globalFormatList('genderTypeList')" :key="`personalGender-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.occupation')" prop="occupation" ref="occupation">
            <el-input v-model="form.occupation" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.race')" prop="race" ref="race">
            <el-select v-model="form.race" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
              <el-option v-for="item of byCountryFormatList('raceTypeData')" :key="`personalRace-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <!-- 马来西亚专属 - RESIDENTIAL ADDRESS -->
    <div class="wdb100 pt20" v-if="isMalaysia">
      <div class="lh40 fs13 black45 fwb postType">
        {{ $t("enroll.intitle.malaysia.residentialAddressTitle") }}
      </div>
      <el-row :gutter="20" class="pt22">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.addressLine1')" prop="residentialAddressLine1" ref="residentialAddressLine1">
            <el-input v-model="form.residentialAddressLine1" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.addressLine2')" prop="residentialAddressLine2" ref="residentialAddressLine2">
            <el-input v-model="form.residentialAddressLine2" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.addressLine3')" prop="residentialAddressLine3" ref="residentialAddressLine3">
            <el-input v-model="form.residentialAddressLine3" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.city')" prop="residentialAddressCity" ref="residentialAddressCity">
            <el-input v-model="form.residentialAddressCity" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.state')" prop="residentialAddressState" ref="residentialAddressState">
            <el-input v-model="form.residentialAddressState" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.postcode')" prop="residentialAddressPostalCode" ref="residentialAddressPostalCode">
            <el-input v-model="form.residentialAddressPostalCode" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.malaysia.country')" prop="residentialAddressCountry" ref="residentialAddressCountry">
            <el-select v-model="form.residentialAddressCountry" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
              <el-option v-for="item of globalFormatList('countryList')" :key="`personalResCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <!-- 马来西亚专属 - SERVICE ADDRESS -->
    <div class="wdb100 pt20" v-if="isMalaysia">
      <div class="lh40 fs13 black45 fwb postType fxVer jcsb">
        <span>{{ $t("enroll.intitle.malaysia.serviceAddressTitle") }}</span>
        <el-checkbox v-model="form.serviceAddressType" :true-label="1" :false-label="2" class="sameAddressCheckbox">
          {{ $t("enroll.intitle.malaysia.sameAsResidentialAddress") }}
        </el-checkbox>
      </div>
      <template v-if="form.serviceAddressType !== 1">
        <el-row :gutter="20" class="pt22">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.addressLine1')" prop="serviceAddressLine1" ref="serviceAddressLine1">
              <el-input v-model="form.serviceAddressLine1" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.addressLine2')" prop="serviceAddressLine2" ref="serviceAddressLine2">
              <el-input v-model="form.serviceAddressLine2" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.addressLine3')" prop="serviceAddressLine3" ref="serviceAddressLine3">
              <el-input v-model="form.serviceAddressLine3" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.city')" prop="serviceAddressCity" ref="serviceAddressCity">
              <el-input v-model="form.serviceAddressCity" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.state')" prop="serviceAddressState" ref="serviceAddressState">
              <el-input v-model="form.serviceAddressState" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.postcode')" prop="serviceAddressPostalCode" ref="serviceAddressPostalCode">
              <el-input v-model="form.serviceAddressPostalCode" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('enroll.intitle.malaysia.country')" prop="serviceAddressCountry" ref="serviceAddressCountry">
              <el-select v-model="form.serviceAddressCountry" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
                <el-option v-for="item of globalFormatList('countryList')" :key="`personalSvcCountry-${item.value}`" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </div>
    <div class="pt20 wdb100 fxRow" v-if="!isReadonly">
      <el-button type="primary" @click="handleAffirm" class="pl20 pr20">{{ $t("common.button.affirm") }}</el-button>
    </div>
  </el-form>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import { validateFormLocation } from "@/utils/common";
import { mapState, mapGetters } from "vuex";

// 可选业务类型集合（用于判断字段是否必填）
const OPTIONAL_BUSINESS_TYPES = ["COMPREHENSIVE_CUSTOMIZED", "FUND_ADMIN_CUSTOMIZED"];

export default {
  name: "FinalBeneficiaryPersonalFormPanel",
  mixins: [validatorMixin],
  props: {
    /** 表单数据对象(弹窗模式: personalForm; 回显模式: 受益人row) */
    form: { type: Object, required: true },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    /** 是否马来西亚（用于显示马来专属的居住地址/服务地址模块） */
    isMalaysia: { type: Boolean, default: false },
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
    isOptionalField() {
      return OPTIONAL_BUSINESS_TYPES.includes(this.applymentDetail.businessType);
    },
    rules() {
      const opt = this.isOptionalField;
      return {
        fullName: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        nationality: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        identificationType: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        identificationNo: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        email: [
          { required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" },
          { type: "email", message: this.$t("common.regular.email"), trigger: "submit" },
        ],
        phone: [{ required: !opt, validator: this.validatePhone, trigger: "submit" }],
        residentialAddress: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        birthDate: [{ required: !opt, validator: this.validateBirthday, trigger: "submit" }],
        isHoldShareOfPrcInland: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        holdShareOfPrcEntity: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        // 马来西亚专属 - 个人额外信息校验
        gender: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        occupation: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        race: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        // 马来西亚专属 - 居住地址/服务地址校验
        residentialAddressLine1: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        serviceAddressLine1: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
      };
    },
  },
  methods: {
    /** 清除校验状态(供父组件通过ref调用) */
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    /** 确认按钮：校验通过后通知父组件提交 */
    handleAffirm() {
      this.$refs.formRef.validate((valid, object) => {
        if (!valid) {
          validateFormLocation(object, this.$refs.formRef);
          return;
        }
        this.$emit("submit");
      });
    },
    // 是否持有中国境内股权 - 变更
    isHoldShareOfPrcInlandChange() {
      if (this.form.isHoldShareOfPrcInland === 0) this.$set(this.form, "holdShareOfPrcEntity", null);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 表单项基础样式(与弹窗内展示保持一致) */
.personalForm ::v-deep {
  .el-form-item__label {
    line-height: 1em;
    padding: 0 0 8px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
}
.postType {
  width: 100%;
  height: 40px;
  background: #f4f8fe;
  padding: 0 20px;
}
.postType ::v-deep .el-form-item__content {
  line-height: 40px;
}
/* 自适应的"与居住地址相同"复选框：抵消外部 .dataForm ::v-deep .el-checkbox 的固定宽度 */
.sameAddressCheckbox {
  width: auto !important;
  margin-right: 0 !important;
  padding-right: 0 !important;
}
</style>

